import { useParams } from "react-router-dom";
import FileSection from "../components/FileSection";

export default function FileInternal() {
  let { fileId } = useParams();

  return (
    <div className="flex grow flex-col items-center">
      {/* Projects */}
      <div className="flex mt-10 w-full lg:w-3/4">
        <FileSection />
      </div>
    </div>
  );
}
